import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import { ButtonBase } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

// project-imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH, USE_SIDEBAR_LOGO_V3_TEST } from 'config';
import sidebarLogoV3Simple from './logo-v3-simple.png';
import sidebarLogoV3TxtDark from './logo-v3-txt-dark.png';
import sidebarLogoV3TxtLight from './logo-v3-txt-light.png';
import { ThemeMode } from 'types/config';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
  variant?: 'default' | 'sidebar';
  useV3Logo?: boolean;
}

const LogoSection = ({ reverse, isIcon, sx, to, variant = 'default', useV3Logo = false }: Props) => {
  const theme = useTheme();
  const useSidebarV3Logo = (USE_SIDEBAR_LOGO_V3_TEST || useV3Logo) && variant === 'sidebar';
  const sidebarLogoV3Txt = theme.palette.mode === ThemeMode.DARK ? sidebarLogoV3TxtDark : sidebarLogoV3TxtLight;

  return (
    <ButtonBase disableRipple component={Link} to={!to ? APP_DEFAULT_PATH : to} sx={sx}>
      {useSidebarV3Logo ? (
        <img
          src={isIcon ? sidebarLogoV3Simple : sidebarLogoV3Txt}
          alt="Habihub"
          style={{
            display: 'block',
            height: isIcon ? 44 : 42,
            width: isIcon ? 44 : 'auto',
            maxWidth: isIcon ? 44 : 168,
            objectFit: 'contain'
          }}
        />
      ) : isIcon ? (
        <LogoIcon />
      ) : (
        <Logo reverse={reverse} />
      )}
    </ButtonBase>
  );
};

export default LogoSection;
